<app-modal *ngIf="vo$ | async; let vo" class="app-task-list-modal">
	<div modal-body class="app-task-modal-content">
		<!-- Filter Tasks -->
		<div class="app-task-list-modal__filter">
			<div class="app-task-list-modal__filter__running__task">
				<mat-icon [svgIcon]="DcIcons.RunningTask"></mat-icon>
				<mat-label i18n="@@task.filter.status.running">Voir uniquement les tâches en cours</mat-label>
				<mat-slide-toggle
					id="{{ cmpId + '-active-job-toggle' }}"
					color="primary"
					[checked]="vo.viewActiveJobs"
					(change)="toggleActiveJobs($event)"
					></mat-slide-toggle>
			</div>
			<div class="app-task-list-modal__filter__cache">
				<mat-icon [svgIcon]="DcIcons.Cache"></mat-icon>
				<mat-label i18n="@@task.filter.active.cache">Cache active</mat-label>
				<mat-slide-toggle
					id="{{ cmpId + '-active-cache-toggle' }}"
					color="primary"
					[checked]="vo.isJobsCacheActive"
					(change)="toggleActiveCache($event)"
					></mat-slide-toggle>
			</div>
		</div>

		<!-- Task List -->
		<app-panel
			class="app-card-outline__headers"
			headerHeight="3rem"
			initialState="true"
			isAlwaysOpen="true"
			hasSearchableGrid="true"
			hasRefresh="true"
			[itemsCount]="vo.list.elements.size"
			[actions]="panelActions"
			(refresh)="refresh()"
			(search)="search($event)"
		>
			<div panel-title class="app-panel__title">
				<mat-icon [svgIcon]="DcIcons.Task"></mat-icon>
				<span i18n="@@task.list.title">
					Toutes les tâches
				</span>
			</div>
			<dx-data-grid
				keyExpr="id"
				[elementAttr]="{ id: 'app-task-list', class: 'app-task-list' }"
				[dataSource]="vo.list.elements | toArray"
				[remoteOperations]="true"
				[hoverStateEnabled]="true"
				[showColumnHeaders]="true"
				[allowColumnResizing]="true"
				[columnAutoWidth]="false"
				[showRowLines]="false"
				[showColumnLines]="false"
				[rowAlternationEnabled]="false"
				[showBorders]="false"
				[height]="'72vh'"
				[width]="'100%'"
				[selection]="{ mode: 'none' }"
				(onContentReady)="onGridContentReady()">

				<dxo-header-filter [visible]="true"></dxo-header-filter>

				<dxo-scrolling mode="virtual"></dxo-scrolling>
				<!-- Fixable in position columns	-->
				<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

				<dxo-load-panel
					shadingColor="rgba(0,0,0,0)"
					[indicatorSrc]="DcLoaders.LoaderInfinite"
					[height]="100"
					[width]="100"
					[enabled]="vo.isFirstLoad"
					[showIndicator]="true"
					[showPane]="true"
					[shading]="true"></dxo-load-panel>

				<ng-container
					*ngFor="let col of vo.list.availableColumns | toArray">
					<dxi-column
						*ngIf="col.field === 'user'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"
						cellTemplate="userTemplate"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'taskType'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"
						cellTemplate="labelTemplate"
						[filterOperations]="[DxOperations.Contains, DxOperations.NotContains, DxOperations.StartsWith, DxOperations.In]"
						[calculateFilterExpression]="calculateTaskTypeHeaderFilterExpression"
						>
							<dxo-header-filter [dataSource]="taskTypeHeaderFilter"></dxo-header-filter>
					</dxi-column>

					<dxi-column
						*ngIf="col.field === 'projectLabel'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"
						cellTemplate="projectLabelTemplate"></dxi-column>

					<dxi-column
						*ngIf="col.field === 'elementLabel'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"
						cellTemplate="elementLabelTemplate"></dxi-column>

					<dxi-column
						*ngIf="col.field === 'elementType'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"
						cellTemplate="elementTypeTemplate"></dxi-column>

					<dxi-column
						*ngIf="col.field === 'status'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"
						cellTemplate="statusTemplate"></dxi-column>

					<dxi-column
						*ngIf="col.field === 'executionTime'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"
						cellTemplate="executionTimeTemplate"
						></dxi-column>

					<dxi-column
						*ngIf="col.field === 'executionDate'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[sortOrder]="'desc'"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"
						cellTemplate="executionDateTemplate"></dxi-column>

					<dxi-column
						*ngIf="col.field === 'submissionDate'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"
						cellTemplate="submissionDateTemplate"></dxi-column>

				</ng-container>

				<dxi-column
						*ngIf="vo.viewActiveJobs"
						[fixed]="false"
						[allowResizing]="false"
						[allowHiding]="false"
						[allowGrouping]="false"
						[allowSearch]="false"
						[allowSorting]="false"
						[alignment]="'left'"
						[visibleIndex]="vo.list.availableColumns.size + 1"
						[showInColumnChooser]="false"
						cellTemplate="actionsTemplate"></dxi-column>

				<div class="user-template" *dxTemplate="let cell of 'userTemplate'">
					<span>
						<app-dc-user [dcUser]="cell.data['user']"></app-dc-user>
					</span>
				</div>

				<div class="label-template" *dxTemplate="let cell of 'labelTemplate'">
					<span>
						{{ cell.data['taskType']?.value }}
					</span>
				</div>

				<div class="project-template" *dxTemplate="let cell of 'projectLabelTemplate'">
					<span>
						{{ cell.data['projectLabel'] }}
					</span>
					<a
						appNavigate
						[hidden]="!cell.data['projectLabel']"
						[navigateTo]="cell.data['projectSourceUrl']">
						<mat-icon
							[svgIcon]="DcIcons.OpenInNewTab"
							matTooltip="open project in new tab"
							i18n-matTooltip="@@task.list.project.sourceTooltip"
							matTooltipPosition="after"></mat-icon>
					</a>
				</div>

				<div class="element-template" *dxTemplate="let cell of 'elementLabelTemplate'">
					<span>
						{{ cell.data['elementLabel'] }}
					</span>
					<a
						appNavigate
						[hidden]="!cell.data['elementLabel']"
						[navigateTo]="cell.data['elementSourceUrl']">
						<mat-icon
							[svgIcon]="DcIcons.OpenInNewTab"
							matTooltip="open element in new tab"
							i18n-matTooltip="@@task.list.element.sourceTooltip"
							matTooltipPosition="after"></mat-icon>
					</a>
				</div>

				<div class="element-type-template" *dxTemplate="let cell of 'elementTypeTemplate'">
					<span>
						{{ cell.data['elementType'] }}
					</span>
				</div>

				<div class="status-template" *dxTemplate="let cell of 'statusTemplate'">
					<span>
						{{ cell.data['status'] }}
					</span>
					<app-overlay-badge
						*ngIf="cell.data['errorMessage']"
						id="{{cell.data['id']}}-task-error-message-overlay"
						[active]="true"
						[icon]="ComponentIcons.Help"
						[isOpen]="vo.openedOverlays.errorMessageTaskId === cell.data['id']"
						(click)="onOpenErrorMessageAction($event, cell.data['id'])">
							<app-popover
								id="task-error-message-popover"
								overlayContent
								[label]="cell.data['taskType']?.value "
								[icon]="{ iconName: ComponentIcons.Help }"
								(adbPopoverClose)="closeOverlay()">
									{{cell.data['errorMessage']}}
							</app-popover>
					</app-overlay-badge>
				</div>

				<div class="execution-time-template" *dxTemplate="let cell of 'executionTimeTemplate'">
					<span>
						{{ cell.data['executionTime']  | dayjsDurationFormat }}
					</span>
				</div>

				<div *dxTemplate="let cell of 'executionDateTemplate'">
					<span>
						{{ cell.data['executionDate'] | date: 'yyyy-MM-dd HH:mm:ss' }}
					</span>
				</div>
				<div *dxTemplate="let cell of 'submissionDateTemplate'">
					<span>
						{{ cell.data['submissionDate'] | date: 'yyyy-MM-dd HH:mm:ss' }}
					</span>
				</div>

				<div
					class="actions-column-template"
					*dxTemplate="let cell of 'actionsTemplate'"
					>
						<button
								id="{{ cmpId }}-{{ cell.rowIndex }}-delete-btn"
								mat-icon-button
								class="actions-column-template__btn"
								matTooltip="delete-task"
								i18n-matTooltip="@@task.list.action.delete"
								(click)="killTask(cell.data)">
								<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
							</button>
				</div>

				<dxo-group-panel [visible]="true"></dxo-group-panel>

				<!-- Search input -->
				<dxo-search-panel [visible]="false"></dxo-search-panel>

				<!-- Filterable columns	-->
				<dxo-filter-row
				[visible]="vo.list.elements.size !== 0"></dxo-filter-row>

				<!-- Sorting	-->
				<dxo-sorting mode="multiple"></dxo-sorting>

				<!-- Pagination -->
				<dxo-paging [pageSize]="20"></dxo-paging>

				<dxo-filter-panel [visible]="true"></dxo-filter-panel>

				<dxo-column-chooser
					[allowSearch]="true"
					[enabled]="false"
					[mode]="'select'">
					<dxo-selection
						[allowSelectAll]="true"
						[recursive]="false"></dxo-selection>
				</dxo-column-chooser>

					<!-- State persistence	-->
					<dxo-state-storing
						type="custom"
						[enabled]="true"
						[savingTimeout]="160"
						[customLoad]="loadState"
						[customSave]="saveState"></dxo-state-storing>
			</dx-data-grid>
		</app-panel>
	</div>
	<div modal-footer class="app-task-list-modal__footer">
		<button
				*ngIf="vo.list.elements.size !== 0"
				id="{{ cmpId }}-create-btn"
				class="app-task-list-modal__footer__btn"
				[color]="'warn'"
				(click)="onKillAllTasksAction()"
				mat-raised-button>
				<span i18n="@@task.action.kill.all">Annuler toutes les tâches</span>
		</button>
		<button
				id="{{ cmpId }}-create-btn"
				class="app-task-list-modal__footer__btn"
				[color]="'warn'"
				(click)="onClearCacheAction()"
				mat-raised-button>
				<span i18n="@@task.action.clear.cache">Vider le cache</span>
		</button>
	</div>
</app-modal>
